import { render, staticRenderFns } from "./DevBpbjWarehousingRecordModal.Style#Drawer.vue?vue&type=template&id=972b6530&scoped=true&"
import script from "./DevBpbjWarehousingRecordModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./DevBpbjWarehousingRecordModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./DevBpbjWarehousingRecordModal.Style#Drawer.vue?vue&type=style&index=0&id=972b6530&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972b6530",
  null
  
)

export default component.exports